export default __webpack_public_path__ + "static/media/1.0fcd1ff4.jpg";